import { render, staticRenderFns } from "./PropertyRateStatementTable.vue?vue&type=template&id=c34331f0"
import script from "./PropertyRateStatementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyRateStatementTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports